import styled from "styled-components";

import { visuallyHiddenCss } from "../../style-utilities/visually-hidden";
import FieldBase, { Template } from "../Field";
import { TextInput } from "../TextField";
import { COUNTRY_CODE_SELECT_WIDTH } from "./components/CountryCodeSelect";

const { ErrorMessage, HelperText } = Template;

const INPUT_GAP = 8;

export const FieldContent = styled.div`
  display: inline-flex;
  gap: ${INPUT_GAP}px;
  width: 100%;
`;

export const CountryCodeSelectorLabel = styled.label`
  ${visuallyHiddenCss};
`;

export const PhoneNumberInput = styled(TextInput)``;

export const Field = styled(FieldBase)`
  ${HelperText},
  ${ErrorMessage} {
    margin-left: ${INPUT_GAP + COUNTRY_CODE_SELECT_WIDTH}px;
  }
`;
